import React, { useState, useMemo, useEffect } from "react";
import { Tabs, TabsList, TabsTrigger } from "../../../../components/ui-custom/Tabs";
import { Clock, CheckCheck, XCircle } from "lucide-react";

const DeliveryStatusFilter = ({
  deliveries,
  onFilterChange,
  activeStatus: controlledActiveStatus,
  onActiveStatusChange,
}) => {
  const [internalActiveStatus, setInternalActiveStatus] = useState("Upcoming");
  const activeStatus = controlledActiveStatus || internalActiveStatus;
  const [filteredDeliveries, setFilteredDeliveries] = useState(
    deliveries.filter((delivery) => delivery.transaction_id === 1),
  );

  useEffect(() => {
    let tempDeliveries = [];
    switch (activeStatus) {
      case "Upcoming":
        tempDeliveries = deliveries.filter((delivery) => delivery.transaction_id === 1);
        break;
      case "Delivered":
        tempDeliveries = deliveries.filter((delivery) => delivery.transaction_id === 2);
        break;
      case "Cancelled":
        tempDeliveries = deliveries.filter((delivery) => delivery.transaction_id === 3);
        break;
      default:
        tempDeliveries = deliveries;
    }
    setFilteredDeliveries(tempDeliveries);
    onFilterChange?.(tempDeliveries, activeStatus);
  }, [deliveries, activeStatus, onFilterChange]);

  const deliveryStats = useMemo(() => {
    return `${filteredDeliveries.length} deliveries`;
  }, [filteredDeliveries]);

  const statusCounts = useMemo(() => {
    return {
      Upcoming: deliveries.filter((d) => d.transaction_id === 1).length,
      Delivered: deliveries.filter((d) => d.transaction_id === 2).length,
      Cancelled: deliveries.filter((d) => d.transaction_id === 3).length,
    };
  }, [deliveries]);

  const handleStatusChange = (status) => {
    if (onActiveStatusChange) {
      onActiveStatusChange(status);
    } else {
      setInternalActiveStatus(status);
    }
  };

  return (
    <div className="w-full">
      <Tabs value={activeStatus} onValueChange={handleStatusChange}>
        <TabsList className="h-9 p-1">
          <TabsTrigger value="Upcoming" className={`h-7 text-sm px-4 gap-1.5 border-none ${activeStatus === "Upcoming" ? "bg-sm-primary text-white" : ""}`}>
            <Clock className="h-3.5 w-3.5" /> Upcoming ({statusCounts.Upcoming})
          </TabsTrigger>
          <TabsTrigger value="Delivered" className={`h-7 text-sm px-4 gap-1.5 border-none ${activeStatus === "Delivered" ? "bg-sm-primary text-white" : ""}`}>
          <CheckCheck className="h-3.5 w-3.5" /> Delivered ({statusCounts.Delivered})
          </TabsTrigger>
          <TabsTrigger value="Cancelled" className={`h-7 text-sm px-4 gap-1.5 border-none ${activeStatus === "Cancelled" ? "bg-sm-primary text-white" : ""}`}>
            <XCircle className="h-3.5 w-3.5" /> Cancelled ({statusCounts.Cancelled})
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};

export default DeliveryStatusFilter;
